import { AxiosInstance, AxiosResponse } from 'axios';
import { TrackingContextProvider } from './helper-services/TrackingContextProvider';
import { LogService } from './data-services/LogService';

export class AxiosServiceConfig {
  static WaitingForToken = false;

  static logService: LogService;

  static setDefaultDecorators = (
    axiosInstance: AxiosInstance,
    logingService: LogService,
    trackingContextProvider: TrackingContextProvider
  ) => {
    AxiosServiceConfig.logService = logingService;
    const requestDefaultErrorHandler = (error: any) => {
      // Do something with request error
      return Promise.reject(error);
    };

    const responseDefaultErrorHandler = (error: any) => {
      try {
        AxiosServiceConfig.logService.logError(error, {
          function: 'AxiosServiceConfig@responseDefaultErrorHandler',
        });
      } catch (error) {
        console.error(error);
      }

      if (error.response && error.response.status === 400 && error.response.data === 'Incorrect SystemId') {
        window.location.reload();
      }
      return Promise.resolve(error.response);
    };

    const responseDefaultDecorator = (response: AxiosResponse<any>) => {
      if (response.headers['content-type'] && response.headers['content-type'].indexOf('application/json') > -1) {
        response.data = {
          isError: false,
          data: response.data,
        };
      }
      return response;
    };

    const requestDecorator = (request: any) => {
      request.headers.BrowserTrackId = trackingContextProvider.browserTrackId;
      request.headers.InstanceTrackId = trackingContextProvider.instanceTrackId;
      return request;
    };

    // Add a request and response interceptor
    axiosInstance.interceptors.request.use(requestDecorator, requestDefaultErrorHandler);
    axiosInstance.interceptors.response.use(responseDefaultDecorator, responseDefaultErrorHandler);
  };
}
